// @flow
import styled, { keyframes } from 'styled-components';

import { Button } from '~/components/widgets/buttons';
import { media } from '~/core/utils/style';
import Modal from 'react-modal';
import SVGIcon from '~/core/icons/svg-icons';

const maxWidth = 28;
const titleHeight = 4.5;
const buttonContainerHeight = 4.75;
const iconSize = 1.5;
const contentPadding = 2;

const reveal = keyframes`
	from { transform: translate3d(100vw, 0, 0); }
	to { transform: translate3d(0, 0, 0); }
`;
const hide = keyframes`
	from { transform: translate3d(0, 0, 0); }
    to { transform: translate3d(100vw, 0, 0); }
`;
const easeOutQuint = 'cubic-bezier(0.23, 1, 0.32, 1)';

export const Main = styled(Modal)`
    animation: ${p => (p.hiding ? hide : reveal)} ${p => (p.hiding ? '0.7s' : '0.3s')} ${easeOutQuint} both;
    background-color: ${p => p.theme.white};
    box-shadow: 0 0 0.5em 0 rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    height: 100%;
    outline: none;
    position: fixed;
    width: 100vw;
    will-change: transform;

    ${media.tablet`
        right: 0;
        width: ${maxWidth}em;
    `};
`;

export const TitleContainer = styled.div`
    align-items: center;
    background-color: ${p => p.theme.secondaryLight};
    display: flex;
    flex: 0 0 ${titleHeight}em;
    padding-left: 2em;
`;

export const Title = styled.div`
    font-size: 1.5em;
    width: ${p => (p.navigationIcon ? `calc(100% - ${iconSize + contentPadding}em)` : '100%')};
    display: ${p => (p.navigationIcon ? `flex` : 'inherit')};
    align-items: ${p => (p.navigationIcon ? `center` : 'inherit')};
    justify-content: ${p => (p.navigationIcon ? `center` : 'inherit')};
`;

export const Content = styled.div`
    flex: 0 0 ${p => (p.showButtons ? `calc(100% - ${titleHeight + buttonContainerHeight}em)` : '100%')};
    overflow: auto;
    -webkit-overflow-scrolling: touch;
`;

export const ButtonsContainer = styled.div`
    background-color: ${p => p.theme.white};
    box-shadow: 0 0 0.5em 0 rgba(0, 0, 0, 0.4);
    flex: 0 0 ${buttonContainerHeight}em;
`;

export const Buttons = styled.div`
    align-items: center;
    display: flex;
    height: ${buttonContainerHeight}em;
    justify-content: space-around;
    padding: 0 8%;

    & > button {
        padding: 0.6em 2.5em;
    }

    ${media.tablet`
		max-width: ${maxWidth}em;
	`};
`;

export const ModalButton = styled(Button)`height: 2.6em;`;

// Unfortunately we cannot use styled component for the overlay
// as react-modal only accepts inline styling
export const overlayStyle = {
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    bottom: 0,
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    transition: 'background-color 0.3s',
    zIndex: 999 // 1 less than the alerts
};

export const overlayStyleHidding = {
    ...overlayStyle,
    backgroundColor: 'rgba(0, 0, 0, 0)'
};

const StatusSVG = styled(SVGIcon)`
    display: inline-block;
    text-align: center;
`;

export const ArrowContainer = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Arrow = StatusSVG.extend`
    width: 1.5em;
    height: 1.5em;
    margin: 0em;
    z-index: 200;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/side-modal/styles.js